import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const PUBLIC = process.env.PUBLIC_URL || '';

/**
 * The LatentStack wordmark (mark + name) from the brand SVG. The dark-ink lettering
 * swaps to a light variant in dark mode, or when `onDark` is set for a dark ground
 * regardless of theme (e.g. the moss footer).
 */
function BrandLogo({ height = 20, onDark, className = '' }) {
  const { theme } = useTheme();
  const light = onDark ?? theme === 'dark';
  return (
    <img
      src={`${PUBLIC}/latentstack-logo${light ? '-light' : ''}.svg`}
      alt="LatentStack"
      className={`block select-none ${className}`}
      style={{ height, width: 'auto' }}
      draggable={false}
    />
  );
}

export default BrandLogo;
